import React from 'react';
import { FileInput, IFileUploadProps } from './FileInput';

export type ImageFileType = 'image/png' | 'image/svg+xml' | 'image/jpeg' | 'image/jpg' | 'image/*';

export interface IImageFile {
  dataURL: string;
  file: File;
}

interface IImageUploadProps extends IFileUploadProps {
  onChange(file: IImageFile): void;
  imageFileType?: ImageFileType | ImageFileType[];
}

const getBase64 = (file: File): Promise<string> => {
  const reader = new FileReader();

  return new Promise(resolve => {
    reader.addEventListener('load', () => resolve(String(reader.result)));

    if (file) reader.readAsDataURL(file);
  });
};

const getImageFileFromList = async (files: FileList): Promise<IImageFile> => {
  const base64 = await getBase64(files[0]);

  return {
    dataURL: base64,
    file: files[0],
  };
};

export const ImageInput: React.FunctionComponent<IImageUploadProps> = ({
  onChange,
  children,
  imageFileType = 'image/png',
  ...props
}) => {
  const selectHandler = async event => {
    const file = await getImageFileFromList(event.target.files);

    onChange(file);
  };

  const fileType = Array.isArray(imageFileType) ? imageFileType.join(',') : imageFileType;

  return (
    <FileInput {...props} onSelect={selectHandler} fileType={fileType}>
      {children}
    </FileInput>
  );
};
